export const paginationOffset = (metadata) => {
  return metadata && metadata.currentPage && metadata.pageSize
    ? metadata.currentPage * metadata.pageSize
    : 0;
};

export const normalizeAdminPagination = (metadata, currentItemCount = 0) => {
  if (!metadata) {
    return null;
  }

  return {
    currentPage: metadata.currentPage ?? 0,
    totalPages: metadata.totalPages ?? 0,
    pageSize: metadata.pageSize,
    totalItems: metadata.totalItems ?? metadata.totalElements ?? metadata.totalCount,
    currentItemCount,
  };
};

export const normalizeSpringPagination = (page, currentItemCount = 0) => {
  if (!page) {
    return null;
  }

  return {
    currentPage: page.number ?? 0,
    totalPages: page.totalPages ?? 0,
    pageSize: page.size,
    totalItems: page.totalElements,
    currentItemCount,
  };
};
